<div class="c-container" *ngIf="!entries.isEmpty()">
  <ng-container *ngFor="let entryIdAndType of entries">
    <rl-view-container-node
      [containerStructure]="containerStructure"
      [entry]="entryIdAndType"
      [entryVisibility]="entryVisibility"
      [sectionsById]="sectionsById"
      class="c-container-node__section__child"
    >
    </rl-view-container-node>
  </ng-container>
</div>

<section *ngIf="entries.isEmpty()" class="list-state list-state--empty">
  <header class="list-state__hero-icon">
    <i class="fas fa-fw fa-list-ul hero-icon" aria-hidden="true"></i>
    <h2 class="delta" i18n="@@container-emptyContainer-title-listIsEmpty">
      This list is empty!
    </h2>
    <p i18n="@@container-emptyContainer-label-checkBackLater">
      It might not always be this way, so check back later&hellip;
    </p>
  </header>
</section>
